import React from 'react';
import { Modal } from 'semantic-ui-react';
import { func, number } from 'prop-types';

import { MediaPermissions } from '../constants';

import css from './NoPermission.less';

function browserDetect() {
  const { userAgent } = navigator;
  let browserName;

  if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = 'Chrome';
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = 'Firefox';
  } else if (userAgent.match(/safari/i)) {
    browserName = 'Safari';
  } else if (userAgent.match(/opr\//i)) {
    browserName = 'Opera';
  } else if (userAgent.match(/edg/i)) {
    browserName = 'Microsoft Edge';
  } else {
    browserName = 'Browser';
  }

  return browserName;
}

function detectOS() {
  const { userAgent } = window.navigator;
  if (userAgent.indexOf('Windows') !== -1) {
    return 'Windows';
  }
  if (userAgent.indexOf('Mac OS') !== -1) {
    return 'Mac OS';
  }
  if (userAgent.indexOf('Linux') !== -1) {
    return 'Linux';
  }
  return '';
}

const getDeviceName = (cameraPermission, micPermission) => {
  if (cameraPermission === MediaPermissions.SystemPermissionDenied) return 'Camera';
  if (micPermission === MediaPermissions.SystemPermissionDenied) return 'Microphone';
  return 'Camera';
};

const CAMERA_WINDOW_PRIVACY = 'ms-settings:privacy-webcam';
const MICROPHONE_WINDOW_PRIVACY = 'ms-settings:privacy-microphone';

const CAMERA_MAC_PRIVACY = 'x-apple.systempreferences:com.apple.preference.security?Privacy_Camera';
const MICROPHONE_MAC_PRIVACY =
  'x-apple.systempreferences:com.apple.preference.security?Privacy_Microphone';

const getPrivacyUrl = (cameraPermission, micPermission) => {
  const os = detectOS();
  if (cameraPermission === MediaPermissions.SystemPermissionDenied) {
    if (os === 'Mac OS') return CAMERA_MAC_PRIVACY;
    if (os === 'Windows') return CAMERA_WINDOW_PRIVACY;
  }
  if (micPermission === MediaPermissions.SystemPermissionDenied) {
    if (os === 'Mac OS') return MICROPHONE_MAC_PRIVACY;
    if (os === 'Windows') return MICROPHONE_WINDOW_PRIVACY;
  }
};

function SystemPermission({ onClose, cameraPermission, micPermission }) {
  const name = getDeviceName(cameraPermission, micPermission);
  const browserName = browserDetect();

  const gotoSettings = () => {
    const url = getPrivacyUrl(cameraPermission, micPermission);
    window.open(url);
  };
  return (
    <Modal
      size="small"
      open
      content={
        <div className={css.container}>
          <div className={css.title}>
            <b>
              Allow {browserName} to access your {name}?
            </b>
          </div>
          <div className={css.content}>
            <p>{name} access is required for video tele-consult in the application.</p>
            <p>To enable this, click Go To Settings below and activate {name} permissions.</p>
          </div>
        </div>
      }
      actions={[
        { key: 'close', content: 'Dismiss', onClick: onClose },
        { key: 'setting', content: 'Go To Settings', onClick: gotoSettings, primary: true },
      ]}
    />
  );
}

SystemPermission.propTypes = {
  onClose: func.isRequired,
  cameraPermission: number,
  micPermission: number,
};

SystemPermission.defaultProps = {
  micPermission: null,
  cameraPermission: null,
};

export default SystemPermission;
